















import ECharts from 'vue-echarts'
import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"
import {GetCompStatistics, GetDlyFrequencyStatistics} from "@/api/report"

@Component({
	components: {ECharts}
})
export default class AdjustPrice extends AbpBase {
	loading = false
	dates: any = []
	date: any = []
	data: any = []
	detailData: any = []
	isTemp = false
	detailShow = false
	echartsData: any = {
		tooltip: {
			trigger: 'item',
			formatter: "{a} <br/>{b}: {c} ({d}%)"
		},
		legend: {
			orient: 'vertical',
			x: 'left',
			data:[]
		},
		series: [
			{
				name:'占比',
				type:'pie',
				radius: ['50%', '70%'],
				avoidLabelOverlap: false,
				label: {
					normal: {
						show: false,
						position: 'center'
					},
					emphasis: {
						show: true,
						textStyle: {
							fontSize: '30',
							fontWeight: 'bold'
						}
					}
				},
				labelLine: {
					normal: {
						show: false
					}
				},
				data:[

				]
			}
		]
	}
	created() {
		const end = new Date();
		const start = new Date();
		end.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
		this.dates = [start, end]
		this.date = [start, end]
		this.init()
	}

	dateChange(e: any) {
		this.dates = e
		this.init()
	}

	options = {
		shortcuts: [
			{
				text: '一周',
				value() {
					const end = new Date();
					const start = new Date();
					end.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
					return [start, end];
				}
			},
			{
				text: '一个月',
				value() {
					const end = new Date();
					const start = new Date();
					end.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
					return [start, end];
				}
			},
			{
				text: '三个月',
				value() {
					const end = new Date();
					const start = new Date();
					end.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
					return [start, end];
				}
			}
		]
	}
	columns = [
		{
			title: '类别',
			key: 'type'
		},
		{
			title: '数量',
			key: 'count'
		},
		{
			title: '占比',
			key: 'ratio'
		},
		{
			title: '操作',
			width: 100,
			render: (h:any, p:any) => {
				return h('Button',{
					props:{type: 'primary'},
					on:{
						click:()=>{
							this.detail(p.row)
						}
					}
				},"详情")
			}
		}
	]
	detailColumns = [
		{
			title: '姓名',
			key: 'patientName'
		},
		{
			title: '性别',
			key: 'sex'
		},
		{
			title: '年龄',
			key: 'age'
		}

	]

	async init() {
		this.loading = true
		let res = await GetDlyFrequencyStatistics()
		this.data = res.objects
		let legendData:any = []
		let seriesData:any = []
		this.data.forEach((item:any)=>{
			legendData.push(item.type)
			seriesData.push({value:item.count, name:item.type})
		})
		this.echartsData.legend.data = legendData
		this.echartsData.series[0].data = seriesData
		this.loading = false
	}

	private detail(row: any) {
		this.detailData = row.items
		this.detailShow = true
	}

	visibleChange(value:boolean){
		if(!value){
			this.detailShow = false
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/dialysisFrequency/index.vue